// @flow
import {pathOr} from 'ramda';

import type {ProductDataForGlobalDataLayerType} from 'constants/flow/flowTypesGlobalDataLayer';
import type {CustomerType} from 'constants/flow/flowTypesCheckout';

import type {ProductReviewsType} from 'reducers/product/reviews/reviewsType';

import {
    getColorValue,
    emptyStringIsFalsy,
    getAttribute,
    getFrameSizeValue,
    getLensTypeValue,
    getGender,
    getGlassesType,
    getProductBadge,
} from '../../helpers';

/**
 * Get fields for Global Data Layer for product page.
 *
 * @param {CustomerType} customer - customer data
 * @namespace
 * @param {Object} data - data
 * @property {MergeProductType} product - active product
 * @property {ProductReviewsType} reviews - reviews items
 * @returns {ProductDataForGlobalDataLayerType} - returned product data prepared for Global Data Layer.
 */
export function getProductDataGlobalDataLayer(
    customer: CustomerType,
    {
        product,
        reviews,
    }: {
        product: any,
        reviews: ProductReviewsType,
    },
): ProductDataForGlobalDataLayerType {
    const image1 = pathOr('', ['media', 'angle', 'src'], product);
    const image2 = pathOr('', ['media', 'front', 'src'], product);
    const image3 = pathOr('', ['media', 'side', 'src'], product);

    return {
        page_type_param1: 'PRODUCT',
        page_type_param2: 'PRODUCT',
        attribute_set: getAttribute(product.type),
        base_price: String(product.price),
        brand: product.brand ? emptyStringIsFalsy(product.brand.label) : '',
        color: getColorValue(product),
        final_price: product.finalPrice,
        frame_url_path: emptyStringIsFalsy(product.url),
        gender: getGender(product.genders),
        glasses_type: getGlassesType(product),
        image_1_url_path: image1,
        image_2_url_path: image2,
        image_3_url_path: image3,
        lens_type: getLensTypeValue(product),
        previous_category_id: emptyStringIsFalsy(customer.previous_category_id),
        previous_category_name: emptyStringIsFalsy(customer.previous_category_name),
        product_badge: getProductBadge(product.badges),
        product_id: String(product.id),
        product_name: emptyStringIsFalsy(product.name),
        size: getFrameSizeValue(product),
        sku: emptyStringIsFalsy(product.sku),
        window_name: emptyStringIsFalsy(product.parentName),
        reviews: Number(reviews.count),
        reviews_images: 0,
    };
}
